"use strict";
/**
 * @fileoverview gRPC-Web generated client stub for V1
 * @enhanceable
 * @public
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginClient = void 0;
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck
var grpcWeb = require("grpc-web");
var v1_login_service_pb = require("../v1/login_service_pb");
var v1_login_types_pb = require("../v1/login_types_pb");
var LoginClient = /** @class */ (function () {
    function LoginClient(hostname, credentials, options) {
        this.methodInfoGet = new grpcWeb.MethodDescriptor('/V1.Login/Get', grpcWeb.MethodType.UNARY, v1_login_service_pb.GetLoginRequest, v1_login_types_pb.LoginDto, function (request) {
            return request.serializeBinary();
        }, v1_login_types_pb.LoginDto.deserializeBinary);
        this.methodInfoCreate = new grpcWeb.MethodDescriptor('/V1.Login/Create', grpcWeb.MethodType.UNARY, v1_login_types_pb.CreateLoginDto, v1_login_types_pb.LoginDto, function (request) {
            return request.serializeBinary();
        }, v1_login_types_pb.LoginDto.deserializeBinary);
        this.methodInfoDelete = new grpcWeb.MethodDescriptor('/V1.Login/Delete', grpcWeb.MethodType.UNARY, v1_login_service_pb.DeleteLoginRequest, v1_login_types_pb.LoginDto, function (request) {
            return request.serializeBinary();
        }, v1_login_types_pb.LoginDto.deserializeBinary);
        this.methodInfoUpdate = new grpcWeb.MethodDescriptor('/V1.Login/Update', grpcWeb.MethodType.UNARY, v1_login_types_pb.UpdateLoginDto, v1_login_types_pb.LoginDto, function (request) {
            return request.serializeBinary();
        }, v1_login_types_pb.LoginDto.deserializeBinary);
        this.methodInfoSetRoles = new grpcWeb.MethodDescriptor('/V1.Login/SetRoles', grpcWeb.MethodType.UNARY, v1_login_types_pb.SetRolesDto, v1_login_types_pb.LoginDto, function (request) {
            return request.serializeBinary();
        }, v1_login_types_pb.LoginDto.deserializeBinary);
        this.methodInfoAssignCloudTelephony = new grpcWeb.MethodDescriptor('/V1.Login/AssignCloudTelephony', grpcWeb.MethodType.UNARY, v1_login_service_pb.AssignCloudTelephonyRequest, v1_login_types_pb.LoginDto, function (request) {
            return request.serializeBinary();
        }, v1_login_types_pb.LoginDto.deserializeBinary);
        this.methodInfoSendInvite = new grpcWeb.MethodDescriptor('/V1.Login/SendInvite', grpcWeb.MethodType.UNARY, v1_login_types_pb.SendInviteDto, v1_login_types_pb.StatusCodeDto, function (request) {
            return request.serializeBinary();
        }, v1_login_types_pb.StatusCodeDto.deserializeBinary);
        this.methodInfoBatchSendInvite = new grpcWeb.MethodDescriptor('/V1.Login/BatchSendInvite', grpcWeb.MethodType.SERVER_STREAMING, v1_login_types_pb.BatchSendInviteDto, v1_login_types_pb.StatusCodeDto, function (request) {
            return request.serializeBinary();
        }, v1_login_types_pb.StatusCodeDto.deserializeBinary);
        if (!options)
            options = {};
        if (!credentials)
            credentials = {};
        options['format'] = 'text';
        this.client_ = new grpcWeb.GrpcWebClientBase(options);
        this.hostname_ = hostname;
        this.credentials_ = credentials;
        this.options_ = options;
    }
    LoginClient.prototype.get = function (request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/V1.Login/Get', request, metadata || {}, this.methodInfoGet, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/V1.Login/Get', request, metadata || {}, this.methodInfoGet);
    };
    LoginClient.prototype.create = function (request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/V1.Login/Create', request, metadata || {}, this.methodInfoCreate, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/V1.Login/Create', request, metadata || {}, this.methodInfoCreate);
    };
    LoginClient.prototype.delete = function (request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/V1.Login/Delete', request, metadata || {}, this.methodInfoDelete, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/V1.Login/Delete', request, metadata || {}, this.methodInfoDelete);
    };
    LoginClient.prototype.update = function (request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/V1.Login/Update', request, metadata || {}, this.methodInfoUpdate, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/V1.Login/Update', request, metadata || {}, this.methodInfoUpdate);
    };
    LoginClient.prototype.setRoles = function (request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/V1.Login/SetRoles', request, metadata || {}, this.methodInfoSetRoles, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/V1.Login/SetRoles', request, metadata || {}, this.methodInfoSetRoles);
    };
    LoginClient.prototype.assignCloudTelephony = function (request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/V1.Login/AssignCloudTelephony', request, metadata || {}, this.methodInfoAssignCloudTelephony, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/V1.Login/AssignCloudTelephony', request, metadata || {}, this.methodInfoAssignCloudTelephony);
    };
    LoginClient.prototype.sendInvite = function (request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/V1.Login/SendInvite', request, metadata || {}, this.methodInfoSendInvite, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/V1.Login/SendInvite', request, metadata || {}, this.methodInfoSendInvite);
    };
    LoginClient.prototype.batchSendInvite = function (request, metadata) {
        return this.client_.serverStreaming(this.hostname_ +
            '/V1.Login/BatchSendInvite', request, metadata || {}, this.methodInfoBatchSendInvite);
    };
    return LoginClient;
}());
exports.LoginClient = LoginClient;
